export default function ListImage({ headline, list, image }) {

	return (
		<section className="container ce_listimage">
			<div className="row align-items-center">
				<div className="col-12 col-lg-5">
					<h2>{headline}</h2>
					<ul>
						{list.map((item, index) => (
							<li key={index} className="item">
								<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12.5 1.5C10.4233 1.5 8.39323 2.11581 6.66652 3.26957C4.9398 4.42332 3.59399 6.0632 2.79927 7.98182C2.00455 9.90045 1.79661 12.0116 2.20176 14.0484C2.6069 16.0852 3.60693 17.9562 5.07538 19.4246C6.54384 20.8931 8.41476 21.8931 10.4516 22.2982C12.4884 22.7034 14.5996 22.4955 16.5182 21.7007C18.4368 20.906 20.0767 19.5602 21.2304 17.8335C22.3842 16.1068 23 14.0767 23 12C23 9.21523 21.8938 6.54451 19.9246 4.57538C17.9555 2.60625 15.2848 1.5 12.5 1.5ZM11 16.1925L7.25001 12.4425L8.44251 11.25L11 13.8075L16.5575 8.25L17.7545 9.4395L11 16.1925Z" fill="#666666"/>
								</svg>
								{item.text}
							</li>
						))}
					</ul>
				</div>
				<div className="col-12 col-lg-6 offset-lg-1">
					<img src={image} />
				</div>
			</div>
		</section>
	);
}
